import { SearchBaseModel } from "../commonModels";

export class ContractPreviewModel {
  public ContractId: number;
  public Name: string;
  public CustomerName: string;
  public DateRange: string;
  public FromDate: Date;
  public ToDate: Date;
  public AcceptByUser: string;
  public AcceptDate: Date;
  public DaysToEnd: number;
  public StatusId: number;
  public Status: string;
  public IsActive: boolean;
  public IsClosed: boolean;
  public IsAfterSale: boolean;
  public SendByUser: string;
  public SendDate: Date;
  public RejectByUser: string;
  public RejectDate: Date;
  public IsOffert: boolean;
  public IsOffertSend: boolean;
  public IsOffertRejected: boolean;
  public IsContract: boolean;
  public StatusAudit: string;
}

export class ContractSearchModel extends SearchBaseModel {
  public CustomerId: number;
  public StatusId: number;
}

export class ContractModel {
  public CustomerId: number;
  public ContractId: number;
  public Name: string;
  public FromDate: Date;
  public ToDate: Date;
  public DaysToEnd: number;
  public StatusId: number;
  public Status: string;
  public AdditionalInformation: string;
  public IsActive: boolean;
  public IsClosed: boolean;
  public HeightTreadToUtilizationSummer: number;
  public HeightTreadToUtilizationWinter: number;
  public HeightTreadToUtilizationAllSeason: number; 
  public IsAfterSale: boolean;
  public AfterSalePeriodId: number;
  public Mhprice: number;
  public AfterSaleForServices: number;
  public SendByUser: string;
  public SendDate: Date;
  public RejectByUser: string;
  public RejectDate: Date;
  public IsOffert: boolean;
  public IsOffertSend: boolean;
  public IsOffertRejected: boolean;
  public IsContract: boolean;
  public StatusAudit: string;

  public DocumentId: number;
  public DocumentAddedByUser: string;
  public DocumentAddDate: Date;

  public ContractExtraParameters: ContractExtraParameterModel[];
}

export class ContractDiscountPreviewModel {
  SummerAfterSaleDiscount: number;
  SummerDiscount: number;
  SummerSumDiscount: number;

  WinterAfterSaleDiscount: number;
  WinterDiscount: number;
  WinterSumDiscount: number;

  AllSeasonAfterSaleDiscount: number;
  AllSeasonDiscount: number;
  AllSeasonSumDiscount: number;

  IsAfterSale: boolean;
  IsSummer: boolean;
  IsWinter: boolean;
  IsAllSeason: boolean;

  ProducerId: number;
  ProducerName: string;
  BrandId: number;
  BrandName: string;
  IsExpanded: boolean;
}

export class SetContractDiscountPreviewModel {
  public ContractId: number;
  public Discounts: ContractDiscountPreviewModel[];
}


export class ContractGarageServicePriceModel {
  public ServiceID: number;
  public IsDefinePrice: boolean;
  public IsGarageSelected: boolean;
  public ServiceName: string;
  public IsCar: boolean;
  public CarAfterSale: number;
  public CarPrice: number;
  public CarPriceWithoutAftersale: number;
  public CarPreviousPrice: number;
  public CarPreviousPriceWithoutAftersale: number;
  public CarDifferencePrice: number;
  public IsTruck: boolean;
  public TruckAfterSale: number;
  public TruckPrice: number;
  public TruckPriceWithoutAftersale: number;
  public TruckPreviousPrice: number;
  public TruckPreviousPriceWithoutAftersale: number;
  public TruckDifferencePrice: number;
  public IsVan: boolean;
  public VanAfterSale: number;
  public VanPrice: number;
  public VanPriceWithoutAftersale: number;
  public VanPreviousPrice: number;
  public VanPreviousPriceWithoutAftersale: number;
  public VanDifferencePrice: number;
  public IsRequireAuthorization: boolean;
}

export class ContractGarageServicePriceSearchModel extends SearchBaseModel {
  public ContractId: number;
  public GarageId: number;
  public IsDefinePrice: boolean;
  public IsActive: boolean;
}

export class ContractDiscountSearch {
  public ContractId: number;
  public IsActive: boolean;
}

export class SetContractGarageServicePriceModel {
  public ContractId: number;
  public GarageId: number;
  public Prices: ContractGarageServicePriceModel[];
}

export class ContractGaragePreviewModel {
  public GarageId: number;
  public Name: string;
  public HasContract: boolean;
}

export class ContractExtraParameterModel {
  public ContractExtraParameterId: number;
  public Name: string;
  public Value: string;
  public ContractId: number;
  public DocumentFile: string | ArrayBuffer;
  public DocumentFileName: string;
}

export class ContractSubCustomerPricePreviewModel {
  public ContractId: number;
  public ServiceId: number;
  public CustomerId: number;
  public ServiceName: string;
  public IsRequireAuthorization: boolean;
}
export class ContractSubCustomerPriceSearch extends SearchBaseModel {
  public ContractId: number;
  public ServiceId: number;
  public CustomerId: number;
}

export class ContractSubCustomerExtraParametersPreviewModel {
  public ContractSubCustomerExtraParameterId: number;
  public ContractId: number;
  public CustomerId: number;
  public Name: string;
  public Value: string;
}
export class ContractSubCustomerExtraParametersSearch extends SearchBaseModel {
  public ContractId: number;
  public CustomerId: number;
}
